import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { IncludesSection } from '../components/IncludesSection';
import { PriceSection } from '../components/PriceSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { OfferToast } from '../components/OfferToast';
export function Landing() {
  const scrollToPrice = useCallback(() => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <div className="w-full bg-crema font-sans text-tinta" data-id="element-206" data-mp="m5hdao9xnoa9">
      <Header onCTA={scrollToPrice} data-id="element-207" data-mp="2b3a4ch2mkm4" />
      <main data-id="element-208" data-mp="27xkmw4j5gpv">
        <Hero onCTA={scrollToPrice} data-id="element-209" data-mp="27nwle31pjmt" />
        <PainSection data-id="element-210" data-mp="3tg1ykpaqxxxn" />
        <TransformationSection data-id="element-211" data-mp="3teryxvo8whow" />
        <WhatIsSection data-id="element-212" data-mp="3tio64oxn0dfv" />
        <HowItWorksSection data-id="element-213" data-mp="3pe82kubhxi3t" />
        <IncludesSection data-id="element-214" data-mp="3pfj5yt114nue" />
        <PriceSection onCTA={scrollToPrice} data-id="element-215" data-mp="3pezw7zlj95rg" />
        <GuaranteeSection data-id="element-216" data-mp="3kg6j48a5rgrt" />
        <FAQSection data-id="element-217" data-mp="3kgyfhlbkxij5" />
        <FinalCTASection onCTA={scrollToPrice} data-id="element-218" data-mp="3khhmi6zoymie" />
      </main>
      <Footer data-id="element-219" data-mp="l0ru5ajdwgmp" />
      <OfferToast data-id="element-220" data-mp="kz8bxee63via" />
    </div>;
}